import { render, staticRenderFns } from "./EvConfigPanel.vue?vue&type=template&id=60891faf&scoped=true"
import script from "./EvConfigPanel.vue?vue&type=script&lang=js"
export * from "./EvConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./EvConfigPanel.vue?vue&type=style&index=0&id=60891faf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60891faf",
  null
  
)

export default component.exports